/**
 * Escape HTML rồi biến URL / email thành thẻ <a> (mở tab mới).
 * An toàn cho v-html: không cho HTML người dùng tự inject.
 */
export function linkifyText(raw) {
    if (raw == null)
        return "";
    let text = String(raw);
    text = text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    text = text.replace(/([^\s@]+@[^\s@]+\.[^\s@]+)/g, '<a target="_blank" rel="noopener noreferrer" href="mailto:$1">$1</a>');
    const urlRegex = /\bhttps?:[^,\s()<>]+(?:\([\w\d]+\)|([^,[:punct:]\s]|))/gi;
    text = text.replace(urlRegex, (url) => {
        let href = url;
        if (!/^https?:\/\//i.test(url)) {
            href = "http://" + url;
        }
        return `<a target="_blank" rel="noopener noreferrer" href="${href}">${url}</a>`;
    });
    return text;
}
